import { createContext, type ReactNode, useEffect, useState } from 'react'
import Keycloak from 'keycloak-js'
import getKeycloakConfig from './keycloak-config'

interface Props {
  children: ReactNode
  predefinedContext: contextType
}

interface contextType {
  keycloak: Keycloak
  initialized: boolean
}

const KeycloakContext = createContext<contextType>({
  keycloak: new Keycloak(undefined),
  initialized: false,
})

const setupKeycloak = async (
  setKeycloak: (arg: Keycloak) => void,
  setInitialized: (arg: boolean) => void,
): Promise<void> => {
  const config = await getKeycloakConfig()
  const configuredKeycloak = new Keycloak(config)
  await configuredKeycloak.init({})

  setKeycloak(configuredKeycloak)
  setInitialized(true)

  configuredKeycloak.onTokenExpired = () => {
    void configuredKeycloak.updateToken(240)
  }
}

export const KeycloakContextProvider: any = ({
  children,
  predefinedContext,
}: Props) => {
  const [keycloak, setKeycloak] = useState<Keycloak>(new Keycloak(undefined))
  const [initialized, setInitialized] = useState<boolean>(false)

  useEffect(() => {
    void setupKeycloak(setKeycloak, setInitialized)
  }, [])

  if (keycloak?.idTokenParsed !== undefined) {
    // TODO: [AV NOTE] When we have the Current User we can see if current user's last login is equal with keycloak?.idTokenParsed.auth_time
    // void UsersApi.login(keycloak)
  }

  const context =
    predefinedContext !== undefined
      ? predefinedContext
      : { keycloak, initialized }

  return (
    <KeycloakContext.Provider value={context}>
      {children}
    </KeycloakContext.Provider>
  )
}

export default KeycloakContext
